<template>
  <v-container style="max-width: 1024px;">
    <v-row justify="center">
      <v-col cols="12">
        <h3 class="display-1 font-weight-regular text-center"
          style="font-variant: small-caps">Laboratory Tests</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4" v-for="i in 12" :key="i">
        <v-card class="mx-auto elevation-2" outlined tile max-width="360px" min-width="290px">
          <!--<v-row class="ma-0">
            <v-col cols="8" class="pa-0">
          <v-row class="pt-2 pb-0 pl-4 pr-2">-->
          <v-row no-gutters>
            <v-col cols="8">
              <v-row align="start" no-gutters>
                <v-col cols="12">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>Blood Pressure</v-list-item-title>
                      <v-list-item-subtitle class="font-weight-light">{{names(i)}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-sparkline
                    :fill="true"
                    :value="values(i)"
                    :gradient="gradient"
                    :smooth="radius || false"
                    :padding="padding"
                    :line-width="width"
                    :stroke-linecap="lineCap"
                    :gradient-direction="gradientDirection"
                    :type="type"
                    :auto-line-width="autoLineWidth"
                    auto-draw
                  ></v-sparkline>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row no-gutters class="fill-height pr-2">
                <v-col cols="12"
                  style="overflow: visible; white-space: nowrap; text-align: right;
                         font-size: 3.8rem; font-weight:500; font-variant: proportional-nums;
                         letter-spacing:-0.15rem; line-height: 5rem; 
                         padding-top:0.5rem;"
                >
                  <div
                    class="blue--text"
                    style="float:right; "
                  ><span>{{ends[i]}}</span></div>
                </v-col>
                <v-col cols="12">
                  <div
                    class="text-right"
                    style="font-size: 0.85rem; font-weight:700; 
                       letter-spacing:normal; line-height: 1rem;
                       width: 100%; margin-top:-0.75rem; padding-right:0.25rem;"
                  >mm Hg</div>
                </v-col>
                <v-col cols="12">
                  <div
                    class="text-right"
                    style="font-size: 0.85rem; font-weight:300; 
                       letter-spacing:normal; line-height: 1.4rem;
                       width: 100%; padding-right:0.25rem;"
                  >June 3, 2020</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>



<script>
const gradients = [["#222"]];
export default {
  data: () => ({
    width: 2,
    radius: 10,
    padding: 12,
    lineCap: "round",
    gradient: ["rgba(10,10,240,0.80)", "rgba(33,150,243,0.20)"],
    value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    gradientDirection: "top",
    gradients,
    fill: false,
    type: "trend",
    autoLineWidth: false,
    ends: []
  }),

  methods: {
    names(i) {
      return (i%2 == 0) ? 'SYSTOLIC' : 'DIASTOLIC'
    },

    values(i) {
      let base =  (i%2 == 0) ? 105 : 70
      let spread = (i%2 == 0) ? 50 : 30
      let v = Array.from({length: 12}, () => base + Math.floor(Math.random() * spread))
      this.ends[i] = v[v.length - 1]
      return v
    }    
  }
};
</script>